import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosExt";
import endpoints from './../../config/endpoints';
import convertByteToImageURL from './../../utils/convertByteToImageURL';
import profilePic from './../../assets/png/default_profile.png';
import { useNavigate } from 'react-router-dom';
import localforage from "localforage";

interface useType {
    [key: string]: any
}

const FirstNameComponent = ({ user }: useType) => {
    

    const navigate = useNavigate();
    const [imageUrl, setImageURL] = useState();
    const goToOverviewPage = () => {
      navigate(`/user-management/view/${user.user_id}`, {
        state: JSON.stringify(user),
      });
    };
    useEffect(() => {
      const callingFunction = async() => {
        if(user.user_id) {
          const buffer = await localforage.getItem(user.user_id);          
          if(buffer){
            const imageurl:any = convertByteToImageURL(buffer);
            setImageURL(imageurl);
          }
          else{
            setImageURL(profilePic)
          }
        }
      }
      callingFunction();
    }, [user.user_id]);
    return  <div className="user-profileWrapper">
      {
        imageUrl ? <div
        className="profile-picture small"
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div> : <img
        className="profile-picture small"
        src={profilePic}
        alt='Profile Image'
      />
      }
    <a onClick={goToOverviewPage}>{user.first_name.value}</a>
  </div>
  }

  export default FirstNameComponent;